import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { AnticipateGovernmentAllocationSchema } from '@/features/privateCompanies/schemas/anticipateGovernmentAllocation.schema'
import { useMutation } from '@tanstack/react-query'

type AnticipateGovernmentAllocationProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useAnticipateGovernmentAllocation = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: AnticipateGovernmentAllocationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['anticipateGovernmentAllocation', governmentAllocationId],
    mutationFn: async (form: AnticipateGovernmentAllocationSchema) => {
      const payload = {
        government_allocation: {
          ...form,
        },
      }

      return privateAxios.put(`/billing/government_allocations/${governmentAllocationId}/anticipate`, payload)
    },
    onSuccess,
    onError,
  })
}
